import { render, staticRenderFns } from "./MenusDemo.vue?vue&type=template&id=b1b827ec&scoped=true&"
import script from "./MenusDemo.vue?vue&type=script&lang=js&"
export * from "./MenusDemo.vue?vue&type=script&lang=js&"
import style0 from "./MenusDemo.vue?vue&type=style&index=0&id=b1b827ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b827ec",
  null
  
)

export default component.exports